<template>
  <div class="sidemenu" v-if="sidemenuData && sidemenuData.menu">
    <h3 class="sidemenu__head">{{ getCaption(sidemenuData.menu.contents[0].title) }}</h3>
    <ul class="sidemenu__list">
      <template v-if="sidemenuData.parentType == 'topmenu'">
        <router-link
          v-for="item in sidemenuData.menu.childEntries.rows"
          :key="item.id"
          :to="item.url"
          tag="li"
          :class="[{'active': currentPath == item.url}, 'sidemenu__item is-pointer']"
        >{{ getCaption(item.contents[0].title) }}</router-link>
      </template>
      <template v-else-if="sidemenuData.parentType == 'submenu'">
        <router-link
          v-for="item in sidemenuData.menu.childEntries.rows"
          :key="item.id"
          :to="item.url"
          tag="li"
          :class="[{'active': item.id == sidemenuData.parentId}, 'sidemenu__item is-pointer']"
        >{{ item.contents[0].title }}</router-link>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    sidemenuData() {
      return this.$store.state.sidemenuData;
    },

    currentPath() {
      return this.$route.path;
    }
  }
};
</script>
